<!-- eslint-disable no-redeclare -->
<template>
  <div id="page">
    <div class="overFixed">
      <div class="flexContainer">
        <Header></Header>
        <!-- <div style="height: 116px;"></div> -->
        <div style="margin-top: -3%; padding: 0 30px; display: flex; justify-content: space-between;">
          <div class="left_column">
            <Charta ref="key"></Charta>
          </div>
          <div class="center_column">
            <div id="map" class="map" style="height: 800px;width: 100%;margin:0 auto;"></div>
          </div>
          <div class="right_column">
            <div class="right-center">
              <Chartb ref="chartb"></Chartb>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import Header from '@/components/Header'
import Charta from '@/components/Charta'
import Chartb from '@/components/Chartb'
import echarts from 'echarts'
import mapJson from '../../assets/shanxi.json'

export default {
  components: {
    Header,
    Charta,
    Chartb
  },
  data() {
    return {
      showHide: 0
    }
  },
  mounted() {
    this.fn()
  },
  methods: {
    fn: function () {
      let _this = this

      _this.axios.post(this.$url.baseUrl + 'index/getCityUser', {
      })
        .then(function (res) {
          console.log(res.data, '城市人员')

          let myChart = echarts.init(document.getElementById('map'))
          console.log(mapJson)
          echarts.registerMap('临汾市', mapJson, {}) //
          var mapJsonlen = mapJson.features.length,
            data = mapJson.features
          var color = [
            '#12245A'
          ]
          var mapData = mapJson.features.map((item, index) => {
            return {
              name: item.properties.name,
              value: 1000,
              level: item.properties.level,
              cityCode: item.properties.adcode,
              itemStyle: {
                normal: {
                  show: true,
                  areaColor: color[index] || '#12245A'
                }
              }
            }
          })

          // eslint-disable-next-line no-redeclare
          var mapData = [
            { name: '大同市', value: 20057.34 },
            { name: '朔州市', value: 15477.48 },
            { name: '忻州市', value: 31686.1 },
            { name: '吕梁市', value: 6992.6 },
            { name: '太原市', value: 44045.49, selected: true },
            { name: '阳泉市', value: 40689.64 },
            { name: '晋中市', value: 37659.78 },
            { name: '长治市', value: 45180.97 },
            { name: '临汾市', value: 45180.97 },
            { name: '晋城市', value: 45180.97 },
            { name: '运城市', value: 45180.97 }
          ]

          // eslint-disable-next-line no-redeclare
          var mapData = res.data

          let option = {

            tooltip: {
              trigger: 'item',
              backgroundColor: 'rgba(0,0,0,0)',
              borderColor: 'rgba(0,0,0,0)',
              extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0);',
              zIndex: 400,
              textStyle: { // 提示框浮层的文本样式。
                color: '#41feff',
                fontStyle: 'normal',
                fontWeight: 'normal',
                fontFamily: 'sans-serif',
                fontSize: 14
              },
              padding: 0, // 提示框浮层内边距，
              formatter: function (params) {
                let showname = params
                return (
                  `
        <div class="section">
            <p class="city">客户城市：${showname.data.name}</p>
            <p class="user">使用人数:${showname.data.value}</p>
      </div>
      `
                )
              }
            },

            series: [
              {
                name: '山西省',
                type: 'map',
                symbol: 'image://./static/guizi/images/044br.gif',
                mapType: '临汾市',
                roam: false, // 是否开启鼠标缩放和平移漫游
                geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
                aspectScale: 0.85, // 地图长度比
                // 鼠标经过高亮显示
                selectedMode: 'single',
                emphasis: {
                  itemStyle: {
                    opacity: 1,
                    borderColor: '#54E7EE',
                    borderWidth: '3',
                    areaColor: '#54E7EE'
                  }
                },
                label: {
                  normal: {
                    show: true, // 是否显示地区名称
                    color: '#ffffff', // 字体的显示颜色
                    fontSize: 12 // 字体大小
                  },
                  emphasis: {
                    show: true,
                    color: '#ffffff' // 鼠标移动上去的字体颜色
                  }
                },
                // eslint-disable-next-line no-dupe-keys
                roam: false,
                itemStyle: {
                  normal: {
                    borderWidth: 2, // 边际线大小
                    borderColor: '#6CF3FA', // 边界线颜色
                    areaColor: '#09295b'// 默认区域颜色
                  },
                  emphasis: {
                    show: true,
                    areaColor: '#54E7EE', // 鼠标滑过区域颜色
                    label: {
                      show: true,
                      textStyle: {
                        color: '#1D4088',
                        fontWeight: 'bold'
                      }
                    }
                  }

                },
                // eslint-disable-next-line no-dupe-keys
                label: {
                  normal: {
                    show: true,
                    textStyle: {
                      color: '#FFFFFF'
                    }
                  }
                },

                data: mapData
                // data:
              }
            ]
          }

          myChart.setOption(option)
          _this.$refs.chartb.mapStateHand();
          myChart.on('click', function (params) {
            // console.log(params.data)
          })

          myChart.on('click', function (res) {
            // console.log(res)
            if (res.componentSubType === 'map') {
              console.log()
              console.log('关键词')
              // alert(`点击了 ${res.name} 地图`);
              // eslint-disable-next-line eqeqeq
              if (sessionStorage.getItem('keywords') != null || sessionStorage.getItem('keywords') != undefined) {
                _this.$router.push('/index/city?map=' + res.name + '&keyword=' + sessionStorage.getItem('keywords'))
              } else {
                _this.$router.push('/index/city?map=' + res.name)
              }
            }
          })

          // 动态显示tooptip，每隔3秒去提示

          var faultByHourIndex = 0 // 播放所在下标

          var faultByHourTime = setInterval(function () {
            // 使得tootip每隔三秒自动显示

            myChart.dispatchAction({

              type: 'showTip', // 根据 tooltip 的配置项显示提示框。

              seriesIndex: 0,

              dataIndex: faultByHourIndex

            })

            faultByHourIndex++

            // faultRateOption.series[0].data.length 是已报名纵坐标数据的长度

            if (faultByHourIndex > mapData.length) {
              faultByHourIndex = 0
            }
          }, 3000)

          // 窗口改变 重新调用绘制地图
          window.addEventListener('resize', () => {
            if (myChart && myChart.resize) {
              myChart.resize()
            }
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style>
.right_column {
  width: 450px;
  height: 93%;
  padding-bottom: 30px;
  float: left;
  display: inline-block;
  margin-left: 1%;
  background: url(../../img/rt_img.png) no-repeat;
  background-size: 100% 100%;
}

.section {
  width: 170px;
  height: 76px;
  background: url("../../img/box.png") no-repeat;
  background-size: 100% 100%;
}

.section p {
  color: #FFFFFF;
  padding-left: 30px;
}

.section .city {
  padding-top: 12px;
}

.section .user {
  margin-top: 6px;
}

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue